export default "__VITE_ASSET__e09cb24d__"